module.exports = __webpack_public_path__ + "img/dell.4fda16ca.svg";